/**
 * Configuration file for API endpoints
 * Uses Vite environment variables for different environments
 * Supports endpoint group-based API URL selection for gradual rollouts
 *
 * TODO: Remove this file once the API migration is complete.
 * All callers of getApiUrl() and buildURL() should be updated to use
 * VITE_API_URL directly, and ENDPOINT_GROUPS/getEndpointGroup can be deleted.
 */
const API_URL = import.meta.env.VITE_API_URL || ''

/**
 * Endpoint Group Configuration
 * Defines which endpoints are on the new API
 * All groups are true; kept for reference and future use
 */
export const ENDPOINT_GROUPS = {
  users: true,
  groups: true,
  userGroups: true,
  userCustomers: true,
  customers: true,
  customerRelation: true,
  applications: true,
  brands: true,
  docs: true,
  devices: true,
  rules: true,
  settings: true,
  moistureSensorStats: true,
  readings: true,
  stats: true,
}

/**
 * Extract endpoint group from URL path
 * @param {string} path - The URL path (e.g., '/users/123', '/customers/456/users')
 * @returns {string} The endpoint group name
 */
export const getEndpointGroup = (path) => {
  // Remove leading slash and get first segment
  const segments = path.replace(/^\//, '').split('/')
  const firstSegment = segments[0]

  // Handle special cases
  if (firstSegment === 'customers' && segments.length > 2) {
    // /customers/{id}/users -> 'customers'
    return 'customers'
  }

  // Handle compound endpoint names
  if (firstSegment === 'moistureSensorStats') {
    return 'moistureSensorStats'
  }

  if (firstSegment === 'customerRelation') {
    return 'customerRelation'
  }

  if (firstSegment === 'userGroups') {
    return 'userGroups'
  }

  if (firstSegment === 'userCustomers') {
    return 'userCustomers'
  }

  // Default to the first segment
  return firstSegment
}

/**
 * Get the appropriate API URL for an endpoint path
 * @returns {string} The API base URL to use
 */
export const getApiUrl = () => {
  return API_URL
}

// Default export for convenience
export default {
  API_URL,
  ENDPOINT_GROUPS,
  getEndpointGroup,
  getApiUrl,
}
